require("webrtc-adapter");
window._ = require("lodash");
window.axios = require("axios");
import axiosRetry from "axios-retry";
const CryptoJS = require("crypto-js");
window.Cookies = require("js-cookie");

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

let hosting = window.location.hostname + ":6001";
let authorization = "";
let langSelect = "";

function encrypt(data) {
    var Sha256 = CryptoJS.SHA256;
    var Hex = CryptoJS.enc.Hex;
    var Utf8 = CryptoJS.enc.Utf8;
    var Base64 = CryptoJS.enc.Base64;
    var AES = CryptoJS.AES;
    let key = Sha256(process.env.MIX_DECRYPT_KEY)
        .toString()
        .toString(Hex)
        .substr(0, 32);
    let iv = Sha256(process.env.MIX_DECRYPT_IV)
        .toString()
        .toString(Hex)
        .substr(0, 16);
    // Encryption
    var output = AES.encrypt(JSON.stringify(data), Utf8.parse(key), {
        iv: Utf8.parse(iv),
    }).toString(); // First Base64 encoding, by default (see 1.)
    var output2ndB64 = Utf8.parse(output).toString(Base64); // Second Base64 encoding (see 1.)
    return output2ndB64;
}

function decrypt(data) {
    var Sha256 = CryptoJS.SHA256;
    var Hex = CryptoJS.enc.Hex;
    var Utf8 = CryptoJS.enc.Utf8;
    var Base64 = CryptoJS.enc.Base64;
    var AES = CryptoJS.AES;
    let key = Sha256(process.env.MIX_DECRYPT_KEY)
        .toString()
        .toString(Hex)
        .substr(0, 32);
    let iv = Sha256(process.env.MIX_DECRYPT_IV)
        .toString()
        .toString(Hex)
        .substr(0, 16);
    // Encryption
    try {
        var output = AES.decrypt(atob(data), Utf8.parse(key), {
            iv: Utf8.parse(iv),
        }).toString(Utf8); // First Base64 encoding, by default (see 1.)
        return JSON.parse(output);
    } catch (error) {
        return null;
    }
}

window.axios.interceptors.request.use(
    function (config) {
        let token = localStorage.getItem("auth-token");
        let key = localStorage.getItem("token");
        let language = localStorage.getItem("lang");
        if (language) {
            let lang = JSON.parse(language);
            langSelect = lang.id;
        }
        if (token) {
            let auth = JSON.parse(token);
            authorization = "Bearer " + auth.access_token;
        }
        if (key) {
            config.headers.common["Authorization"] = "Bearer "+key;
            localStorage.removeItem("token");
        }else{
            config.headers.common["Authorization"] = authorization;
        }
        config.headers.common["X-Requested-With"] = "XMLHttpRequest";
        config.headers.common["lang"] = langSelect;
        if (process.env.MIX_DECRYPT_ENABLE === "true") {
            config.data = { data: encrypt(config.data) };
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

window.axios.interceptors.response.use(
    function (response) {
        if (process.env.MIX_DECRYPT_ENABLE === "true") {
            if (response.data) {
                if (response.data.data) {
                    let decode = {
                        decode: {
                            data: decrypt(response.data.data),
                        },
                    };
                    response = { ...response, ...decode };
                }
            }
        }
        return response;
    },
    function (error) {
        if (error.response.status === 401 && localStorage.getItem('auth-token') != null) {
            localStorage.removeItem('csrf_tokenizer');
            localStorage.removeItem('auth-token');
            if (location.pathname.includes('/nfc')) {
                location.href = "/nfc/login";
            } else {
                window.location.reload();
            }
        }
        if (process.env.MIX_DECRYPT_ENABLE === "true") {
            if (error.response) {
                if (error.response.data) {
                    let decode = {
                        decode: {
                            data: decrypt(error.response.data.data),
                        },
                    };
                    error.response = { ...error.response, ...decode };
                }
            }
        }
        return Promise.reject(error);
    }
);

axiosRetry(axios, { retries: 3 });

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

let token = localStorage.getItem("auth-token");
if (token) {
    let auth = JSON.parse(token);
    authorization = "Bearer " + auth.access_token;
}

import Echo from "laravel-echo";
window.io = require("socket.io-client");

// if (typeof io !== "undefined") {
//     window.Echo = new Echo({
//         broadcaster: "socket.io",
//         host: hosting,
//         auth: { headers: {Authorization: authorization} }
//     });
// }
